(() => {
  const LEGAL_PAGE_SELECTOR = '[data-legal-page]';
  const LINK_SELECTOR = '[data-legal-anchor-link]';
  const ACTIVE_CLASS = 'is-active';

  const setActiveLink = (links, activeTargetId) => {
    links.forEach((link) => {
      const isActive = link.dataset.targetId === activeTargetId;
      link.classList.toggle(ACTIVE_CLASS, isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const getScrollOffset = () => {
    const rootStyles = window.getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
    return headerHeight + 24;
  };

  const setupLegalPage = (legalPage) => {
    const links = Array.from(legalPage.querySelectorAll(LINK_SELECTOR));
    if (!links.length) return;

    const targets = links
      .map((heading) => {
        const targetId = heading.dataset.targetId;
        if (!targetId) return null;

        const target = legalPage.querySelector(`#${CSS.escape(targetId)}`) || document.getElementById(targetId);
        if (!target) {
          heading.classList.add('legal-page__nav-link--disabled');
          heading.setAttribute('aria-disabled', 'true');
          heading.setAttribute('tabindex', '-1');
          heading.removeAttribute('href');
          return null;
        }

        return { link: heading, target, targetId };
      })
      .filter(Boolean);

    if (!targets.length) {
      legalPage.querySelector('.legal-page__sidebar')?.setAttribute('hidden', 'hidden');
      return;
    }

    const activeLinks = targets.map(({ link }) => link);

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((entryA, entryB) => entryB.intersectionRatio - entryA.intersectionRatio);

        if (!visible.length) return;
        const activeTargetId = visible[0].target.id;
        setActiveLink(activeLinks, activeTargetId);
      },
      {
        root: null,
        rootMargin: `-${getScrollOffset()}px 0px -55% 0px`,
        threshold: [0.2, 0.5, 0.8],
      },
    );

    targets.forEach(({ target }) => observer.observe(target));

    activeLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.dataset.targetId;
        if (!targetId) return;

        const target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();
        const destination = target.getBoundingClientRect().top + window.scrollY - getScrollOffset();

        window.history.replaceState(null, '', `#${targetId}`);
        window.scrollTo({ top: destination, behavior: 'smooth' });
        setActiveLink(activeLinks, targetId);
      });
    });

    const hashTargetId = window.location.hash.replace('#', '');
    if (hashTargetId) {
      const hashTarget = targets.find(({ targetId }) => targetId === hashTargetId);
      if (hashTarget) setActiveLink(activeLinks, hashTargetId);
      return;
    }

    setActiveLink(activeLinks, targets[0].targetId);
  };

  const init = () => {
    document.querySelectorAll(LEGAL_PAGE_SELECTOR).forEach(setupLegalPage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    return;
  }

  init();
})();
